import { CandidateRating, Candidate } from '../../types';

export interface Job {
  id: string;
  title: string;
  department: string;
  location: string;
  type: 'Full-time' | 'Part-time' | 'Contract' | 'Internship';
  salary: string;
  postedDate: string;
  deadline: string;
  status: 'Open' | 'Closed' | 'Draft';
  applicants: number;
  description: string;
  requirements: string[];
  /** Apply on the website opens the full seafarer form (→ Candidates) */
  useSeafarerForm?: boolean;
}

export interface Application {
  id: string;
  /** Holds the applied-position title (candidates store the title, not a job id) */
  jobId: string;
  candidateName: string;
  email: string;
  phone: string;
  appliedDate: string;
  status: 'Pending' | 'Reviewed' | 'Interview' | 'Hired' | 'Rejected';
  /** Raw Strapi candidate_status enum — display `status` is the mapped label */
  rawStatus?: string;
  resume: string;
  rating: CandidateRating[];
  totalRating: number;
  evaluatedBy?: string;
  evaluatedAt?: string;
  notes?: string;
  /** Full candidate record — needed to populate the view/edit forms */
  rawCandidate?: Candidate;
}

export const convertEmploymentTypeFromAPI = (type: string): Job['type'] => {
  const typeMap: Record<string, Job['type']> = {
    'full_time': 'Full-time',
    'part_time': 'Part-time',
    'contract': 'Contract',
    'temporary': 'Internship'
  };
  return typeMap[type] || 'Full-time';
};

export const convertEmploymentTypeToAPI = (type: string): string => {
  const typeMap: Record<string, string> = {
    'Full-time': 'full_time',
    'Part-time': 'part_time',
    'Contract': 'contract',
    'Internship': 'temporary'
  };
  return typeMap[type] || 'full_time';
};

export const getStatusBadge = (status: string): string => {
  const colors: Record<string, string> = {
    'Open': 'bg-green-100 text-green-800',
    'Closed': 'bg-red-100 text-red-800',
    'Draft': 'bg-yellow-100 text-yellow-800',
    'Pending': 'bg-blue-100 text-blue-800',
    'Reviewed': 'bg-purple-100 text-purple-800',
    'Interview': 'bg-orange-100 text-orange-800',
    'Hired': 'bg-green-100 text-green-800',
    'Rejected': 'bg-red-100 text-red-800'
  };
  return colors[status] || 'bg-gray-100 text-gray-800';
};
